<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width" v-if="success === false">

                <v-row>
                    <v-col
                            cols="12"
                            md="6"
                            offset-md="1"
                    >
                    <v-stepper v-model="e1" v-if="basketProductsCount > 0" class="form-card">
                        <v-stepper-header>
                            <v-stepper-step :complete="e1 > 1" step="1">{{ $t('Delivery') }}</v-stepper-step>

                            <v-divider></v-divider>

<!--                            <v-stepper-step :complete="e1 > 2" step="2">Postage</v-stepper-step>-->

<!--                            <v-divider></v-divider>-->

                            <v-stepper-step step="2">{{ $t('Secure payment') }}</v-stepper-step>
                        </v-stepper-header>


                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-card
                                        elevation="0"
                                >
                                    <v-card-title class="headline primary--text">{{ $t('headings.Delivery address') }}</v-card-title>

                                    <v-card-text class="text--primary">
                                        <div v-if="delivery.name !== ''">
                                            <v-form v-model="deliveryValid" @submit.prevent="validateDelivery">
                                                <ValidationObserver ref="deliveryObserver">
                                                    <ValidationProvider vid="delivery.name" :name="$t('labels.Name')" rules="required" v-slot="{ errors }">
                                                        <v-text-field
                                                                v-model="delivery.name"
                                                                :error-messages="errors[0]"
                                                                :label="$t('labels.Name')"
                                                                required
                                                        ></v-text-field>
                                                    </ValidationProvider>

                                                    <ValidationProvider vid="delivery.postcode" :name="$t('labels.Postcode')" rules="required" v-slot="{ errors }">
                                                        <v-text-field
                                                                v-model="delivery.postcode"
                                                                :error-messages="errors[0]"
                                                                :label="$t('labels.Postcode')"
                                                                required
                                                        ></v-text-field>
                                                        <v-btn v-if="brand === 'findmykit'" @click="postcodeLookup" class="mb-6">{{ $t('buttons.Lookup address from postcode') }}</v-btn>
                                                    </ValidationProvider>

                                                    <v-select
                                                            v-if="addresses.length > 0"
                                                            :items="addresses"
                                                            :label="$t('labels.Choose address')"
                                                            v-on:change="setAddress"
                                                            autofocus
                                                    ></v-select>

                                                    <ValidationProvider vid="delivery.address1" :name="$t('labels.Address line 1')" rules="required" v-slot="{ errors }">
                                                        <v-text-field
                                                                v-model="delivery.address1"
                                                                :error-messages="errors[0]"
                                                                :label="$t('labels.Address line 1')"
                                                                required
                                                        ></v-text-field>
                                                    </ValidationProvider>

                                                    <ValidationProvider vid="delivery.address2" :name="$t('labels.Address line 2')" v-slot="{ errors }">
                                                        <v-text-field
                                                                v-model="delivery.address2"
                                                                :error-messages="errors[0]"
                                                                :label="$t('labels.Address line 2')"
                                                                required
                                                        ></v-text-field>
                                                    </ValidationProvider>

                                                    <ValidationProvider vid="delivery.town" :name="$t('labels.Town')" rules="required" v-slot="{ errors }">
                                                        <v-text-field
                                                                v-model="delivery.town"
                                                                :error-messages="errors[0]"
                                                                :label="$t('labels.Town')"
                                                                required
                                                        ></v-text-field>
                                                    </ValidationProvider>

                                                    <ValidationProvider vid="delivery.county" :name="$t('labels.County')" rules="required" v-slot="{ errors }">
                                                        <v-text-field
                                                                v-model="delivery.county"
                                                                :error-messages="errors[0]"
                                                                :label="$t('labels.County')"
                                                                required
                                                        ></v-text-field>
                                                    </ValidationProvider>

                                                    <ValidationProvider vid="delivery.country" :name="$t('labels.Country')" rules="required" v-slot="{ errors }">
                                                        <v-select
                                                                :items="countriesList"
                                                                item-text="name"
                                                                item-value="code"
                                                                v-model="delivery.country"
                                                                :error-messages="errors[0]"
                                                                :label="$t('labels.Country')"
                                                                required
                                                        ></v-select>
                                                    </ValidationProvider>

                                                    <ValidationProvider vid="delivery.terms" :name="$t('labels.Terms')" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
                                                      <v-checkbox
                                                          v-model="delivery.terms"
                                                          :error-messages="errors[0]"
                                                          required
                                                      >
                                                        <template v-slot:label>
                                                          <div>
                                                            {{ $t('I have read the') }}
                                                            <v-tooltip bottom>
                                                              <template v-slot:activator="{ on }">
                                                                <a
                                                                    @click.prevent.stop="dialog = true"
                                                                    v-on="on"
                                                                >
                                                                  {{ $t('terms and conditions') }}
                                                                </a>
                                                                <v-dialog
                                                                    v-model="dialog"
                                                                    max-width="600"
                                                                >
                                                                  <v-card>
                                                                    <v-card-title class="headline">{{ $t('headings.Terms and conditions') }}</v-card-title>

                                                                    <v-card-text>
                                                                      <TermsContent/>
                                                                    </v-card-text>

                                                                    <v-card-actions>
                                                                      <v-spacer></v-spacer>

                                                                      <v-btn
                                                                          color="green darken-1"
                                                                          text
                                                                          @click="rejectTerms"
                                                                      >
                                                                        {{ $t('buttons.Disagree') }}
                                                                      </v-btn>

                                                                      <v-btn
                                                                          color="green darken-1"
                                                                          text
                                                                          @click="acceptTerms"
                                                                      >
                                                                        {{ $t('buttons.Agree') }}
                                                                      </v-btn>
                                                                    </v-card-actions>
                                                                  </v-card>
                                                                </v-dialog>
                                                              </template>
                                                              {{ $t('Opens in popover') }}
                                                            </v-tooltip>
                                                          </div>
                                                        </template>
                                                      </v-checkbox>
                                                    </ValidationProvider>
                                                </ValidationObserver>

                                            </v-form>
                                        </div>
                                        <v-sheet
                                                v-else
                                                class="px-3 pt-3 pb-3"
                                        >
                                            <p class="text-center"><v-icon>mdi mdi-36px mdi-spin mdi-loading</v-icon></p>
                                        </v-sheet>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-row>
                                            <v-col class="d-flex justify-end">
                                                <v-btn
                                                        color="primary"
                                                        @click="validateDelivery"
                                                        rounded
                                                        elevation="0"
                                                >
                                                    {{ $t('buttons.Continue') }}<v-icon dark right>mdi-arrow-right</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-card>



                            </v-stepper-content>

                            <v-stepper-content step="2">
                                <v-card
                                        v-if="productsTotal > 0"
                                        elevation="0"
                                >
                                    <v-card-title class="headline primary--text">{{ $t('Please enter your payment details') }}</v-card-title>

                                    <v-card-text class="text--primary pr-2">

<!--                                        <v-form v-model="billingValid" @submit.prevent="validateBilling">-->
<!--                                            <ValidationObserver ref="billingObserver">-->
<!--                                                <ValidationProvider vid="billing.name" :name="$t('labels.Name')" rules="required" v-slot="{ errors }">-->
<!--                                                    <v-text-field-->
<!--                                                            v-model="billing.name"-->
<!--                                                            :error-messages="errors[0]"-->
<!--                                                            :label="$t('labels.Name on card')"-->
<!--                                                            required-->
<!--                                                    ></v-text-field>-->
<!--                                                </ValidationProvider>-->

<!--                                                <ValidationProvider vid="billing.terms" :name="$t('labels.Terms')" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">-->
<!--                                                    <v-checkbox-->
<!--                                                            v-model="billing.terms"-->
<!--                                                            :error-messages="errors[0]"-->
<!--                                                            required-->
<!--                                                    >-->
<!--                                                        <template v-slot:label>-->
<!--                                                            <div>-->
<!--                                                                {{ $t('I have read the') }}-->
<!--                                                                <v-tooltip bottom>-->
<!--                                                                    <template v-slot:activator="{ on }">-->
<!--                                                                        <a-->
<!--                                                                            @click.prevent.stop="dialog = true"-->
<!--                                                                            v-on="on"-->
<!--                                                                        >-->
<!--                                                                            {{ $t('terms and conditions') }}-->
<!--                                                                        </a>-->
<!--                                                                        <v-dialog-->
<!--                                                                                v-model="dialog"-->
<!--                                                                                max-width="600"-->
<!--                                                                        >-->
<!--                                                                            <v-card>-->
<!--                                                                                <v-card-title class="headline">{{ $t('headings.Terms and conditions') }}</v-card-title>-->

<!--                                                                                <v-card-text>-->
<!--                                                                                    <TermsContent/>-->
<!--                                                                                </v-card-text>-->

<!--                                                                                <v-card-actions>-->
<!--                                                                                    <v-spacer></v-spacer>-->

<!--                                                                                    <v-btn-->
<!--                                                                                            color="green darken-1"-->
<!--                                                                                            text-->
<!--                                                                                            @click="rejectTerms"-->
<!--                                                                                    >-->
<!--                                                                                        {{ $t('buttons.Disagree') }}-->
<!--                                                                                    </v-btn>-->

<!--                                                                                    <v-btn-->
<!--                                                                                            color="green darken-1"-->
<!--                                                                                            text-->
<!--                                                                                            @click="acceptTerms"-->
<!--                                                                                    >-->
<!--                                                                                        {{ $t('buttons.Agree') }}-->
<!--                                                                                    </v-btn>-->
<!--                                                                                </v-card-actions>-->
<!--                                                                            </v-card>-->
<!--                                                                        </v-dialog>-->
<!--                                                                    </template>-->
<!--                                                                    {{ $t('Opens in popover') }}-->
<!--                                                                </v-tooltip>-->
<!--                                                            </div>-->
<!--                                                        </template>-->
<!--                                                    </v-checkbox>-->
<!--                                                </ValidationProvider>-->
<!--                                            </ValidationObserver>-->
<!--                                          <v-btn @click="validateBilling">Proceed to payment</v-btn>-->
<!--                                        </v-form>-->
                                        <v-dialog
                                                v-model="stripeDialog"
                                                persistent
                                                width="300"
                                        >
                                            <v-card
                                                    color="primary"
                                                    dark
                                            >
                                                <v-card-text class="pa-6">
                                                    <h3 class="text-h6">{{ $t('headings.Please wait while we verify your card') }}</h3>
                                                    <v-progress-linear
                                                            indeterminate
                                                            color="white"
                                                            class="mb-6 mt-6"
                                                    ></v-progress-linear>
                                                </v-card-text>
                                            </v-card>
                                        </v-dialog>
<!--                                        <card v-if="mountStripeElement" class='stripe-card'-->
<!--                                              ref='card'-->
<!--                                              :class='{ complete }'-->
<!--                                              :stripe='stripeKey'-->
<!--                                              :options='stripeOptions'-->
<!--                                              @change='complete = $event.complete'-->
<!--                                        />-->
<!--                                      <StripeElements-->
<!--                                          :stripe-key="stripeKey"-->
<!--                                          :instance-options="instanceOptions"-->
<!--                                          :elements-options="stripeOptions"-->
<!--                                          #default="{ elements }"-->
<!--                                      ref="elms"-->
<!--                                      >-->
<!--                                      <StripeElement-->
<!--                                          type="card"-->
<!--                                          :elements="elements"-->
<!--                                          :options="cardOptions"-->
<!--                                          ref="card"-->
<!--                                      />-->
<!--                                      </StripeElements>-->
                                        <div id="payment-element"></div>

<!--                                        <stripe-element-card ref="card" class="mb-2" v-if="mountStripeElement" :pk="stripeKey" :elementsOptions='stripeOptions' @token="tokenCreated" />-->
                                        <div class="mt-6 mr-2">
                                          <v-btn elevation="0" block @click='pay' :disabled='stripeDialog === true' :loading="loading" color="primary">{{ $t('buttons.Pay with credit card') }}<v-icon
                                              right
                                              dark
                                          >
                                            mdi-lock
                                          </v-icon></v-btn>
                                        </div>
<!--                                        <v-btn class="clear-button" @click="clearCard">Clear</v-btn>-->
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-row>
                                            <v-col class="d-flex justify-space-between">
                                                <v-btn
                                                        color="primary"
                                                        @click="e1 = 1"
                                                        rounded
                                                        elevation="0"
                                                >
                                                    <v-icon dark left>mdi-arrow-left</v-icon>{{ $t('buttons.Back') }}
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-card>
                                <v-card
                                        v-else
                                        elevation="0"
                                >
                                    <v-card-title class="headline primary--text">{{ $t('headings.No payment needed') }}. {{ $t('headings.Please confirm your order') }}.</v-card-title>

                                    <v-card-text class="text--primary">
                                        <v-form v-model="billingClaimValid" @submit.prevent="claim">
                                            <ValidationObserver ref="billingClaimObserver">
                                                <ValidationProvider vid="billing.terms" :name="$t('labels.Terms')" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
                                                    <v-checkbox
                                                            v-model="billing.terms"
                                                            :error-messages="errors[0]"
                                                            required
                                                    >
                                                        <template v-slot:label>
                                                            <div>
                                                                {{ $t('I have read the') }}
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <a
                                                                                @click.prevent.stop="dialog = true"
                                                                                v-on="on"
                                                                        >
                                                                            {{ $t('terms and conditions') }}
                                                                        </a>
                                                                        <v-dialog
                                                                                v-model="dialog"
                                                                                max-width="600"
                                                                        >
                                                                            <v-card>
                                                                                <v-card-title class="headline">{{ $t('headings.Terms and conditions') }}</v-card-title>

                                                                                <v-card-text>
                                                                                    <TermsContent/>
                                                                                </v-card-text>

                                                                                <v-card-actions>
                                                                                    <v-spacer></v-spacer>

                                                                                    <v-btn
                                                                                            color="green darken-1"
                                                                                            text
                                                                                            @click="rejectTerms"
                                                                                    >
                                                                                      {{ $t('buttons.Disagree') }}
                                                                                    </v-btn>

                                                                                    <v-btn
                                                                                            color="green darken-1"
                                                                                            text
                                                                                            @click="acceptTerms"
                                                                                    >
                                                                                        {{ $t('buttons.Agree') }}
                                                                                    </v-btn>
                                                                                </v-card-actions>
                                                                            </v-card>
                                                                        </v-dialog>
                                                                    </template>
                                                                    {{ $t('Opens in popover') }}
                                                                </v-tooltip>
                                                            </div>
                                                        </template>
                                                    </v-checkbox>
                                                </ValidationProvider>
                                            </ValidationObserver>
                                        </v-form>

                                        <v-btn class="mt-6" rounded elevation="0" block @click='claim' color="primary">{{ $t('buttons.Confirm order') }}</v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>

                </v-col>
                <v-col
                    md="4"
                    class="text-left"
                >
                    <v-card
                            class="basket-card"
                            elevation="0"
                            :class="{'basket-right': $vuetify.breakpoint.mdAndUp}"
                    >
                        <h2 class="headline primary--text">Basket</h2>

                        <v-list
                                v-if="basketProductsCount > 0"
                        >
                            <v-list-item
                                    v-for="(product,index) in basketProducts"
                                    :key="index"
                            >

                                <v-list-item-content>
                                    <v-card
                                            elevation="0"
                                    >
                                        <div class="d-flex flex-no-wrap">

                                            <v-img
                                                    v-if="product.image"
                                                    :src="require('@/assets/' + product.image)"
                                                    class="primary"
                                                    max-width="160"
                                                    max-height="100"
                                            ></v-img>

                                            <div class="basket-detail">
                                                <v-card-title
                                                        class="title pt-0"
                                                        v-text="product.name"
                                                ></v-card-title>

                                                <p class="body-2" v-if="product.quantity > 1">{{ brand === 'neotag' ? '€' : '£'}}{{ product.price }} each</p>
                                                <p class="body-2" v-else>{{ brand === 'neotag' ? '€' : '£'}}{{ product.price }}</p>
                                                <p class="body-2" v-if="product.quantity > 1">{{ $t('Quantity: {quantity}', {quantity: product.quantity}) }}</p>
                                                <p v-if="product.dependant && product.dependant.name">{{ $t('For {name}', {name: product.dependant.name}) }}</p>
                                                <p v-else-if="product.activate !== true && product.personalisable === true">{{ $t('For {name}', {name: usersName}) }}</p>

                                            </div>
                                        </div>
                                    </v-card>
                                </v-list-item-content>

                            </v-list-item>

                            <div class="totals">
                                <div class="d-flex justify-space-between">
                                    <p class="title">{{ $t('Sub-total') }}</p>
                                    <p class="title text-right">{{ brand === 'neotag' ? '€' : '£'}}{{ productsTotal ? productsTotal : '0.00' }}</p>
                                </div>
                                <div class="d-flex justify-space-between" v-if="voucherDiscount > 0">
                                    <p class="title">{{ $t('Voucher applied') }}</p>
                                    <p class="title text-right">-{{ brand === 'neotag' ? '€' : '£'}}{{voucherDiscount}}</p>
                                </div>
                                <div class="d-flex justify-space-between">
                                    <p class="title">{{ $t('Postage') }}</p>
                                    <p class="title text-right">{{ $t('FREE') }}</p>
                                </div>
                                <div class="d-flex justify-space-between" v-if="basketTotal">
                                    <p class="title">{{ $t('Total') }}</p>
                                    <p class="title text-right" v-if="basketTotal">{{ brand === 'neotag' ? '€' : '£'}}{{ basketTotal }}</p>
                                </div>
                            </div>


                        </v-list>
                    </v-card>

                </v-col>
                </v-row>
            </v-container>
            <v-container v-if="success">
                <v-row>
                    <v-col
                            cols="12"
                            md="8"
                            offset-md="2"
                    >
                        <h1 class="mt-6 mb-6">{{ $t('headings.Confirmation') }}</h1>
                        <v-card
                                class="mx-auto product-card"
                                outlined
                        >
                            <v-card-title class="headline primary--text">{{ $t('Order number: {number}', {number: payment.id}) }}</v-card-title>

                            <v-card-text class="text--primary">

                                <h2 class="title font-weight-medium">{{ $t('headings.Delivery address') }}</h2>
                                {{ payment.delivery_name }}<br>
                                {{ payment.delivery_address1 }}<br>
                                <span v-if="payment.delivery_address2">{{ payment.delivery_address2 }}<br></span>
                                {{ payment.delivery_town }}<br>
                                {{ payment.delivery_county }}<br>
                                {{ payment.delivery_postcode }}<br>
                                {{ payment.delivery_country }}<br>

                                <v-list>
                                    <v-subheader class="subtitle-1">{{ $t('headings.Items ordered') }}</v-subheader>
                                    <v-list-item
                                            v-for="(payment_item,index) in payment.payment_items"
                                            :key="index"
                                    >
                                        <v-list-item-icon>
                                            <router-link
                                                    :to="{ name: 'product', params: {slug: payment_item.product.slug} }"
                                            >
                                                <v-img
                                                        v-if="payment_item.product.image"
                                                        :src="require('@/assets/' + payment_item.product.image)"
                                                        aspect-ratio="1.6"
                                                        class="primary"
                                                        min-width="160"
                                                        min-height="80"
                                                ></v-img>
                                            </router-link>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title class="subtitle-2"><router-link
                                                    :to="{ name: 'product', params: {slug: payment_item.product.slug} }"
                                            >{{ payment_item.product.name }}</router-link></v-list-item-title>
                                            <v-list-item-subtitle class="body-2" v-if="payment_item.quantity > 1">{{ brand === 'neotag' ? '€' : '£'}}{{ payment_item.product.price }} each</v-list-item-subtitle>
                                            <v-list-item-subtitle class="body-2" v-else>{{ brand === 'neotag' ? '€' : '£'}}{{ payment_item.product.price }}</v-list-item-subtitle>
                                            <v-list-item-subtitle class="body-2" v-if="payment_item.quantity > 1">{{ $t('Quantity: ', {quantity: payment_item.quantity}) }}</v-list-item-subtitle>
                                            <v-list-item-subtitle v-if="payment_item.dependant">{{ $t('For {name}', {name: payment_item.dependant.name}) }}</v-list-item-subtitle>
                                            <v-list-item-subtitle v-else-if="payment_item.product.activate !== true && payment_item.product.personalisable === true">{{ $t('For {name}', {name: payment_item.user.name}) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>

                                <div class="totals">
                                    <div class="d-flex justify-space-between" v-if="payment.discount > 0">
                                        <p class="title">{{ $t('Voucher applied') }}</p>
                                        <p class="title text-right">-{{ brand === 'neotag' ? '€' : '£'}}{{payment.discount}}</p>
                                    </div>
                                    <div class="d-flex justify-space-between">
                                        <p class="title">{{ $t('Postage') }}</p>
                                        <p class="title text-right">{{ $t('FREE') }}</p>
                                    </div>
                                    <div class="d-flex justify-space-between">
                                        <p class="title">{{ $t('Total') }}</p>
                                        <p class="title text-right">{{ brand === 'neotag' ? '€' : '£'}}{{ payment.amount > 0 ? payment.amount : 0.00 }}</p>
                                    </div>
                                </div>

                                <p class="font-weight-bold">{{ $t('Personalised products will be posted separately within 6/8 weeks') }}.</p>

                            </v-card-text>

                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import { stripeService } from '../services'
    import { store } from '../store'
    import axios from 'axios';

    import { mapGetters, mapState, mapActions } from 'vuex'

    import Footer from './Footer.vue'
    import TermsContent from './TermsContent'
    import {i18n} from "../i18n";

    import { loadStripe } from '@stripe/stripe-js'
    import * as Sentry from "@sentry/vue";

    export default {
        name: "Checkout",
        components: {
            'Footer': Footer,
            'TermsContent': TermsContent
        },
        metaInfo () {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Checkout'),
            htmlAttrs: {
              lang: i18n.locale
            },
          }
        },
        data () {
            return {
                addresses: [],
                mountStripeElement: false,
                stripeKey: process.env.VUE_APP_STRIPE_KEY,
                success: false,
                payment: null,
                dialog: false,
                stripeDialog: false,
                deliveryObserver: '',
                postageObserver: '',
                billingObserver: '',
                billingClaimObserver: '',
                delivery: {
                    name: '',
                    address1: '',
                    address2: '',
                    town: '',
                    county: '',
                    postcode: '',
                    country: '',
                    terms: false
                },
                billing: {
                    name: '',
                    terms: false
                },
                deliveryValid: false,
                postageValid: false,
                billingValid: false,
                billingClaimValid: false,
                complete: false,
                declined: false,
                e1: 1,
                postageOptions: [],
                show: false,
                token: null,
                stripe: null,
                elementsObject: null,
                clientSecretObject: null,
                paymentFormLoaded: false,
                loading: false
            }
        },
        computed: {
            ...mapGetters('basket', ['postage']),
            ...mapState({
                user: state => state.account.user,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            usersName () {
                let user = this.user

                if (user) {
                    return user.name
                }
                else {
                    return ''
                }
            },
            voucherDiscount () {
                return store.getters['basket/voucherDiscount']
            },
            voucher () {
                return store.getters['basket/voucher']
            },
            productsTotal () {
                let productsTotal = store.getters['basket/productsTotal']
                return productsTotal
            },
            basketTotal () {
                let basketTotal = store.getters['basket/basketTotal'] - store.getters['basket/voucherDiscount']
                return basketTotal.toFixed(2)
            },
            postageChosen () {
                if (this.postage > 0) {

                    if (this.postage) {
                        let postageOption = this.postageOptions.find(el => el.id === this.postage);
                        if (postageOption) {
                            let postagePrice = parseFloat(postageOption.price)
                            console.log(postagePrice.toFixed(2))
                            return postagePrice.toFixed(2)
                        }
                    }
                }
                return false
            },
            basketProductsCount () {
                return store.getters['basket/productsCount']
            },
            basketProducts () {
                return store.getters['basket/products']
            },
            productForCreateMany () {
                return store.getters['basket/productForCreateMany']
            },
            countriesList () {
              return [
                {name: i18n.t('United Kingdom'), code: 'GB'},
                {name: i18n.t('Singapore'), code: 'SG'},
                {name: i18n.t('Spain'), code: 'ES'},
              ]
            },
            containsOnlyPostFree () {
                return store.getters['basket/containsOnlyPostFree']
            }
        },

        methods: {
            ...mapActions('account', ['updateBundleClaimedAt']),
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            tokenCreated (token) {
              console.log(token);
              // handle the token
              // send it to your server
              this.token = token
              this.complete = true
            },
            acceptTerms() {
                this.dialog = false
                this.billing.terms = true
            },
            rejectTerms() {
                this.dialog = false
                this.billing.terms = false
            },
            validateDelivery () {
                this.$refs.deliveryObserver.validate().then(success => {
                        if (this.deliveryValid) {

                            this.e1 = 2
                            window.scrollTo(0,0);

                            if (this.basketTotal > 0) {

                              this.loadPaymentForm()
                            }
                        }
                    }
                )
            },
            async loadPaymentForm () {
              this.stripe = await loadStripe(this.stripeKey);

              stripeService.createIntent(this.basketTotal, this.brand, this.voucherDiscount, this.productForCreateMany, this.delivery, this.voucher).then(response => {

                this.clientSecretObject = response.client_secret
                console.log(this.clientSecretObject)
                let clientSecret = this.clientSecretObject

                const appearance = {
                  theme: this.brand.neotag ? 'night' : 'default'
                };
                const options = { /* options */ };
                let elements = this.stripe.elements({ clientSecret, appearance });
                this.elementsObject = elements
                console.log(this.elementsObject)
                const paymentElement = elements.create('payment', options);
                paymentElement.mount('#payment-element');
                this.paymentFormLoaded = true
              })

              this.mountStripeElement = true;
            },
            validatePostage () {
                this.$refs.postageObserver.validate().then(success => {
                        if (this.postageValid) {
                            this.e1 = 3
                        }
                    }

                )
            },
            async pay () {
              this.loading = true

              let elements = this.elementsObject

              let domain = (new URL(window.location));

              let that = this;

              this.stripe.confirmPayment(
                  {
                    elements,
                    redirect: 'if_required',
                    confirmParams: {
                      return_url: 'https://' + domain.hostname + "/account",
                    }
                  }
              ).then(function (result) {
                if (result.paymentIntent) {
                  if (result.paymentIntent.status === 'succeeded') {

                    stripeService.setPaymentStatus(result.paymentIntent).then(success => {
                      if (success) {
                        that.loading = false
                        that.success = true;
                        that.payment = success.data;
                        store.dispatch('basket/clear').then();
                        //that.clearCard()
                        that.stripeDialog = false
                      }
                    })

                  }
                  if (result.paymentIntent.status === 'processing') {
                    Sentry.captureMessage("Checkout payment intent status processing");
                  }

                }
                else if(result.error) {
                  that.loading = false
                  that.stripeDialog = false
                  store.dispatch('alert/error', i18n.t('Payment Failed, please try another card'), { root: true }).then();
                }
              }).catch(function (error) {
                console.log(error)
                that.loading = false
                that.stripeDialog = false
              });
            },
            // payOld () {
            //   this.stripeDialog = true
            //
            //   let that = this
            //
            //   let elements = this.elements
            //
            //   stripe.confirmPayment({
            //         elements,
            //         redirect: 'if_required'
            //       }
            //   ).then(function(result) {
            //
            //     if (result.paymentIntent) {
            //       if (result.paymentIntent.status === 'succeeded') {
            //
            //         stripeService.setPaymentStatus(result.paymentIntent).then(success => {
            //           if (success) {
            //             that.success = true;
            //             that.payment = success.data;
            //             store.dispatch('basket/clear').then();
            //             //that.clearCard()
            //             that.stripeDialog = false
            //           }
            //         })
            //
            //       }
            //
            //     }
            //     else if(result.error) {
            //       that.stripeDialog = false
            //       store.dispatch('alert/error', i18n.t('Payment Failed, please try another card'), { root: true }).then();
            //     }
            //   }).catch(function (error) {
            //     console.log(error)
            //     that.stripeDialog = false
            //   });
            // },
            clearCard () {
              if (this.$refs.card) {
                this.$refs.card.clear() // "card" reference is defined in template above
              }
            },
            claim () {

                this.$refs.billingClaimObserver.validate().then(() => {

                    if (this.billingClaimValid === true) {
                        let data = {
                            delivery: this.delivery,
                            billing: this.billing,
                            products: this.productForCreateMany,
                            brand: this.brand
                        }

                        let that = this

                        let apiClient = axios.create({
                            baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                            withCredentials: true,
                        });

                        return apiClient
                            .post('/api/payments/claim', data)
                            .then(response => {

                                // login successful if there's a jwt token in the response
                                if (response.status === 201 && response.data) {
                                    //store.dispatch('alert/success', 'Success', { root: true }).then();
                                    that.success = true;
                                    that.payment = response.data.data;

                                    let bundleClaimedAt = response.data.data.user.bundle_claimed_at

                                    that.updateBundleClaimedAt(bundleClaimedAt).then(() => {
                                        store.dispatch('basket/clear').then();
                                        that.clearCard()
                                        that.stripeDialog = false
                                    })
                                }

                                return response.data;
                            })
                            .catch(function (error) {
                                if (error.response) {
                                    // The request was made and the server responded with a status code
                                    // that falls out of the range of 2xx
                                    console.log(error.response.data);
                                    console.log(error.response.status);
                                    console.log(error.response.headers);
                                    if (error.response.data.bundle_claimed_at) {
                                        store.dispatch('alert/error', i18n.t('You have already claimed your free bundle on {date}', {date: error.response.data.bundle_claimed_at}), { root: true }).then();
                                    }
                                    else {
                                        store.dispatch('alert/error', i18n.t('Failed'), { root: true }).then();
                                    }


                                } else if (error.request) {
                                    // The request was made but no response was received
                                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                                    // http.ClientRequest in node.js
                                    console.log(error.request);
                                } else if (error.message) {
                                    // Something happened in setting up the request that triggered an Error
                                    console.log(error.message);
                                } else {
                                    // The login was rejected due to incorrect role
                                    return Promise.reject(error);
                                }
                            });
                    }

                })


            },
            postcodeLookup () {
                const { delivery } = this;

                if (delivery.postcode) {

                    this.addresses = []

                    axios
                        .get('https://api.getAddress.io/find/' + delivery.postcode + '?api-key=' + process.env.VUE_APP_GET_ADDRESS_API_KEY)
                        .then(response => {
                            console.log(response.data)
                            this.addresses = response.data.addresses
                        })
                        .catch(error => {
                            console.log(error)
                        })
                }
            },
            setAddress (a) {
                console.log(a)
                this.delivery.addresses = []
                let address = a.split(",");
                this.delivery.address1 = address[0]
                this.delivery.address2 = address[1]
                this.delivery.town = address[5]
                this.delivery.county = address[6]
                this.delivery.country = 'GB'
            },
        },
        mounted () {



          //let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY),

            console.log(process.env.VUE_APP_STRIPE_KEY)

            window.scrollTo(0,0);

            // axios
            //     .get('/api/postage')
            //     .then(response => {
            //         this.postageOptions = response.data.data
            //     })
            //     .catch(error => {
            //         console.log(error)
            //     })

            let apiClient = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                withCredentials: true,
            });

            apiClient
                .get('/api/users/self')
                .then(response => {
                    let user = response.data.data
                    this.delivery.name = user.name
                    this.delivery.address1 = user.address1
                    this.delivery.address2 = user.address2
                    this.delivery.town = user.town
                    this.delivery.county = user.county
                    this.delivery.postcode = user.postcode
                    this.delivery.country = user.country
                })
                .catch(error => {
                    console.log(error)
                })
        },
    }
</script>

<style scoped>
    .basket-card {
        border-radius: 15px !important;
        padding: 20px;
        min-height: 300px;
    }
    .stripe-card {
        border: 1px solid grey !important;
        box-sizing: border-box;

        height: 40px;

        padding: 10px 12px;
        margin: 20px 0;

        border: 1px solid transparent;
        border-radius: 4px;
        /*background-color: white;*/

        /*box-shadow: 0 1px 3px 0 #e6ebf1;*/
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
    }
    .stripe-card.complete {
        border-color: green;
    }

    .stripe-card--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .stripe-card--invalid {
        border-color: #fa755a;
    }

    .stripe-card--webkit-autofill {
        background-color: #fefde5 !important;
    }

    .pay-with-stripe {
        /*display: block;*/
        /*background: #666ee8;*/
        /*color: #000;*/
        /*box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);*/
        /*border-radius: 4px;*/
        /*border: 0;*/
        /*font-weight: 700;*/
        /*width: 100%;*/
        /*height: 40px;*/
        /*outline: none;*/
        /*cursor: pointer;*/
        /*transition: all 0.15s ease;*/
    }

    .pay-with-stripe:focus {
        background: #555abf;
    }

    .pay-with-stripe:hover {
        transform: translateY(-1px);
        box-shadow: 0 7px 14px 0 rgba(50, 50, 93, 0.1),
        0 3px 6px 0 rgba(0, 0, 0, 0.08);
    }

    .clear-button {
        margin-top: 20px;
    }

    .totals {
        padding: 10px 10px 0 10px;
    }
    .total {
        margin-right: 20px;
    }
    .basket-right {
        /*margin-top: 73px;*/
    }
    .basket-detail p {
        padding: 0 16px;
    }
    .basket-card .v-list-item {
        padding: 0 !important;
    }

    .v-stepper, .v-stepper__header {
        box-shadow: none !important;
        border-bottom: solid grey 1px;
        /*background-color: #fff !important;*/
    }
    /*.v-stepper__items {*/
    /*    padding: 0 !important;*/
    /*}*/
    .v-stepper__content {
        padding: 0 !important;
    }
    /*.v-stepper__label,*/
    /*.theme--light.v-stepper .v-stepper__label,*/
    /*.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {*/
    /*    color: #fff !important;*/
    /*}*/
    /*.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {*/
    /*    color: #fff !important;*/
    /*}*/
    /*.theme--light.v-stepper .v-stepper__header .v-divider {*/
    /*    border-color: rgba(255, 255, 255, 0.5) !important;*/
    /*}*/
    /*.v-stepper__step__step.primary {*/
    /*    color: #fff !important;*/
    /*}*/
    /*.v-stepper__step__step {*/
    /*    background-color: #fff !important;*/
    /*    color: #000 !important;*/
    /*}*/
</style>
